<template lang="pug">
  LayoutDefault
    Headline(variant="success")

    .section
      PromotionBanner

      GoNotification(v-if="eInvestGoStatus === 1")


    .container-fluid
      .row
        .col-lg-6
          .section: .card: .card--body
            AssetSummary

          .section: .card: .card--body
            StockNews(@clickOnStockNews="OPEN_INFO_MODAL")

        .col-lg-6
          .section: .card: .card--body
            PersonalizedEvents

      .row
        .col-md-12
          .section: .card: .card--body
            SBLIncomePredictor
  
    NewsModal(
      :modalShow="newsModal.isShown",
      :news="newsModal.payload", 
      @close="newsModal.isShown = false"
    )

</template>



<script>
import { mapState } from 'vuex';

import Headline from '@/components/Headline';
import AssetSummary from '@/components/AssetSummary';
import StockNews from '@/components/StockNews';
import PersonalizedEvents from '@/components/PersonalizedEvents';
import SBLIncomePredictor from '@/components/SBLIncomePredictor';
import PromotionBanner from '@/components/PromotionBanner';
import GoNotification from '@/components/GoNotification';
import NewsModal from '@/components/NewsModal';

export default {
  components: { 
    AssetSummary,
    StockNews,
    PersonalizedEvents,
    SBLIncomePredictor,
    PromotionBanner,
    GoNotification,
    NewsModal,
    Headline
  },

  data: () => ({
    newsModal: {
      isShown: false,
      payload: {},
    },
  }),

  computed: {
    ...mapState('auth', [
      'currentUser'
    ]),

    eInvestGoStatus() {
      return this.currentUser.nf2fCallAction;
    },
  },

  methods: {
    OPEN_INFO_MODAL(payload) {
      this.newsModal.payload = payload;
      this.newsModal.isShown = true;
    },
  },
}
</script>